import {
  Spacing,
  Colors,
  BorderRadius,
  Breakpoints,
} from '@doordash/design-language'
import * as React from 'react'
import { ComponentPropsWithoutRef } from 'react'
import styled from 'styled-components'
import useBodyBackgroundColor from '../../../hooks/useBodyStyle'
import { useMediaQuery } from 'react-responsive'

export const maxWidthPx = 632

/**
 * Component which renders children in a sensible, centered way.
 * Good for responsive, horizontally centered pages.
 */
const ResponsiveNarrow: React.FC<ComponentPropsWithoutRef<'div'>> = ({
  children,
  ...props
}) => {
  const isDesktop = useMediaQuery({
    query: `(min-width: ${Breakpoints.Mobile}px)`,
  })
  useBodyBackgroundColor(isDesktop ? Colors.SystemGrey0 : undefined)

  return (
    <ResponsiveNarrowContainer {...props}>
      <ContentContainer isDesktop={isDesktop}>{children}</ContentContainer>
    </ResponsiveNarrowContainer>
  )
}

const ResponsiveNarrowContainer = styled.div`
  display: grid;
  grid-template-areas:
    '. .       .'
    '. content .'
    '. .       .';
  grid-template-columns: minmax(0, 1fr) minmax(auto, ${maxWidthPx}px) minmax(
      0,
      1fr
    );
  grid-template-rows: 92px auto 1fr;

  height: 100%;
`

const ContentContainer = styled.div<{ isDesktop: boolean }>`
  grid-area: content;
  padding: ${Spacing.Small}px;

  ${({ isDesktop }) =>
    isDesktop &&
    `
    margin: ${Spacing.Small}px;
    padding: ${Spacing.Small}px ${Spacing.Small +
      Spacing.XxxLarge}px ${Spacing.Small + Spacing.XxxLarge}px;
    border-radius: ${BorderRadius.Medium}px;
    border: 1px solid ${Colors.SystemGrey5};
  `}

  background-color: ${Colors.SystemWhite};
`

export default ResponsiveNarrow
